import React from 'react'
import { parseToReactElement } from '../../utils/html'

const GpaContact = props => (
  <span>{parseToReactElement(props.children)}</span>
)

export default GpaContact